import { msg } from '@lingui/core/macro'
import {
  ColouredMga,
  ColouredRgf,
  Facebook,
  Instagram,
  X,
  AgeRestriction,
} from '@vgw/multibrand-fe-icon'

export const FOOTER_LOGOS = [
  {
    icon: ColouredMga,
    title: msg`Read Malta Gaming Authority document to learn more`,
    url: 'https://authorisation.mga.org.mt/verification.aspx?lang=EN&company=4debab56-21d5-49fd-96c5-1c2b5500dbb4&details=1',
    className: 'w-auto h-9',
  },
  {
    icon: ColouredRgf,
    title: msg`Visit Responsible Gaming Foundation to learn more`,
    url: 'https://www.rgf.org.mt',
    className: 'size-9',
  },
  {
    icon: AgeRestriction,
    title: msg`Visit Gaming Addicts Anonymous to learn more`,
    url: 'https://cgaa.info',
    className: 'size-9',
  },
] as const

export const SOCIAL_MEDIA_LOGOS = [
  {
    icon: Facebook,
    title: msg`Go to Facebook`,
    url: 'https://www.facebook.com',
    className: 'size-5',
  },
  {
    icon: Instagram,
    title: msg`Go to Instagram`,
    url: 'https://www.instagram.com',
    className: 'size-5',
  },
  {
    icon: X,
    title: msg`Go to Twitter`,
    url: 'https://twitter.com',
    className: 'size-5',
  },
] as const
